

export const getStorageItem = (key: string) => {
    return localStorage.getItem(key) || '';
}

export const removeStorageItem = (key: string) => {
    localStorage.removeItem(key);
}

export const clearStorage = () => {
    const rememberEmail = localStorage.getItem("remember_email");
    const rememberPassword = localStorage.getItem("remember_password");

    localStorage.clear();

    // Restore remember me credentials
    if (rememberEmail) localStorage.setItem("remember_email", rememberEmail);
    if (rememberPassword) localStorage.setItem("remember_password", rememberPassword);
}

export const setStorageItem = (key: string, value: any) => {
    localStorage.setItem(key, value);
}